import axios from 'axios';

export const getRooms = () => axios({
  url: `${process.env.REACT_APP_API_HOST}/room`,
  method: 'GET',
  headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}` || ""
  }
}).then(response => response.data.data)


export const getRoom = (cacheKeyBase, cacheKeyId) => {
  return axios({
      url: `${process.env.REACT_APP_API_HOST}/room/${cacheKeyId}`,
      method: 'GET',
      headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}` || ""
      }
  }).then(response => response.data.data)
}

export const postRoom = ({ room }) => axios({
  url: `${process.env.REACT_APP_API_HOST}/room`,
  method: 'POST',
  data: room,
  headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}` || ""
  },
}).then(response => response.data.data);


export const putRoom = ({ _id, room }) => axios({
  url: `${process.env.REACT_APP_API_HOST}/room/${_id}`,
  method: 'PATCH',
  data: room,
  headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}` || ""
  },
}).then(response => response.data.data);


export const checkRoomLive = ({ _id }) => axios({
    url: `${process.env.REACT_APP_API_HOST}/room/live/${_id}`,
    method: 'GET',
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}` || ""
    },
}).then(response => response.data.data);


export const deleteRoom = ({ _id }) => axios({
  url: `${process.env.REACT_APP_API_HOST}/room/${_id}`,
  method: 'DELETE',
  headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}` || ""
  },
}).then(response => response.data.data);
